import { jsx as _jsx } from "react/jsx-runtime";
import { FaUndoAlt } from "@superwall/icons/fa/FaUndoAlt";
import { IoArrowForwardCircleSharp } from "@superwall/icons/io5/IoArrowForwardCircleSharp";
import { IoFlashOffSharp } from "@superwall/icons/io5/IoFlashOffSharp";
import { IoFlashSharp } from "@superwall/icons/io5/IoFlashSharp";
import { IoPencilOutline } from "@superwall/icons/io5/IoPencilOutline";
import { IoTrashOutline } from "@superwall/icons/io5/IoTrashOutline";
import { MdAdd } from "@superwall/icons/md/MdAdd";
import { MdAddBox } from "@superwall/icons/md/MdAddBox";
import { MdAddCircle } from "@superwall/icons/md/MdAddCircle";
import { MdArrowBack } from "@superwall/icons/md/MdArrowBack";
import { MdArrowBackIos } from "@superwall/icons/md/MdArrowBackIos";
import { MdArrowDownward } from "@superwall/icons/md/MdArrowDownward";
import { MdArrowForward } from "@superwall/icons/md/MdArrowForward";
import { MdArrowUpward } from "@superwall/icons/md/MdArrowUpward";
import { MdBolt } from "@superwall/icons/md/MdBolt";
import { MdCheck } from "@superwall/icons/md/MdCheck";
import { MdChevronRight } from "@superwall/icons/md/MdChevronRight";
import { MdClose } from "@superwall/icons/md/MdClose";
import { MdContentCopy } from "@superwall/icons/md/MdContentCopy";
import { MdCrop169 } from "@superwall/icons/md/MdCrop169";
import { MdCropDin } from "@superwall/icons/md/MdCropDin";
import { MdCropSquare } from "@superwall/icons/md/MdCropSquare";
import { MdDescription } from "@superwall/icons/md/MdDescription";
import { MdExpandLess } from "@superwall/icons/md/MdExpandLess";
import { MdExpandMore } from "@superwall/icons/md/MdExpandMore";
import { MdFormatListBulleted } from "@superwall/icons/md/MdFormatListBulleted";
import { MdHorizontalRule } from "@superwall/icons/md/MdHorizontalRule";
import { MdInfoOutline } from "@superwall/icons/md/MdInfoOutline";
import { MdInsertDriveFile } from "@superwall/icons/md/MdInsertDriveFile";
import { MdLayersClear } from "@superwall/icons/md/MdLayersClear";
import { MdLock } from "@superwall/icons/md/MdLock";
import { MdModeEditOutline } from "@superwall/icons/md/MdModeEditOutline";
import { MdOfflineBolt } from "@superwall/icons/md/MdOfflineBolt";
import { MdOndemandVideo } from "@superwall/icons/md/MdOndemandVideo";
import { MdOpenInBrowser } from "@superwall/icons/md/MdOpenInBrowser";
import { MdOpenInNew } from "@superwall/icons/md/MdOpenInNew";
import { MdOutlineAdd } from "@superwall/icons/md/MdOutlineAdd";
import { MdOutlineBurstMode } from "@superwall/icons/md/MdOutlineBurstMode";
import { MdOutlineCloseFullscreen } from "@superwall/icons/md/MdOutlineCloseFullscreen";
import { MdOutlineCode } from "@superwall/icons/md/MdOutlineCode";
import { MdOutlineFileDownload } from "@superwall/icons/md/MdOutlineFileDownload";
import { MdOutlineFileUpload } from "@superwall/icons/md/MdOutlineFileUpload";
import { MdOutlineFilterNone } from "@superwall/icons/md/MdOutlineFilterNone";
import { MdOutlineImage } from "@superwall/icons/md/MdOutlineImage";
import { MdOutlineRateReview } from "@superwall/icons/md/MdOutlineRateReview";
import { MdOutlineSelectAll } from "@superwall/icons/md/MdOutlineSelectAll";
import { MdOutlineStorage } from "@superwall/icons/md/MdOutlineStorage";
import { MdOutlineSubtitles } from "@superwall/icons/md/MdOutlineSubtitles";
import { MdOutlineTableChart } from "@superwall/icons/md/MdOutlineTableChart";
import { MdOutlineTableRows } from "@superwall/icons/md/MdOutlineTableRows";
import { MdOutlineTitle } from "@superwall/icons/md/MdOutlineTitle";
import { MdOutlineViewDay } from "@superwall/icons/md/MdOutlineViewDay";
import { MdOutlineWidthFull } from "@superwall/icons/md/MdOutlineWidthFull";
import { MdPhotoFilter } from "@superwall/icons/md/MdPhotoFilter";
import { MdRedo } from "@superwall/icons/md/MdRedo";
import { MdRefresh } from "@superwall/icons/md/MdRefresh";
import { MdSmartButton } from "@superwall/icons/md/MdSmartButton";
import { MdStarHalf } from "@superwall/icons/md/MdStarHalf";
import { MdStayCurrentLandscape } from "@superwall/icons/md/MdStayCurrentLandscape";
import { MdStayCurrentPortrait } from "@superwall/icons/md/MdStayCurrentPortrait";
import { MdStoreMallDirectory } from "@superwall/icons/md/MdStoreMallDirectory";
import { MdSubdirectoryArrowLeft } from "@superwall/icons/md/MdSubdirectoryArrowLeft";
import { MdTextFields } from "@superwall/icons/md/MdTextFields";
import { MdUndo } from "@superwall/icons/md/MdUndo";
import tw from "tailwind-styled-components";
import Gear from "./custom/Gear";
import Goal from "./custom/Goal";
import Grid from "./custom/Grid";
import Menu from "./custom/Menu";
import Pencil from "./custom/Pencil";
import Photo from "./custom/Photo";
import Plus from "./custom/Plus";
import Polaroid from "./custom/Polaroid";
import Text from "./custom/Text";
/**
 * PLEASE READ
 *
 * To add additional icons import them from react-icons and add them
 * to the `Icons` map below. Then you can reference the new icon(s)
 * by the import name.
 */ const Io5Icons = {
    IoArrowForwardCircleSharp,
    IoFlashOffSharp,
    IoFlashSharp,
    IoPencilOutline,
    IoTrashOutline
};
const MdIcons = {
    FaUndoAlt,
    MdAdd,
    MdAddBox,
    MdAddCircle,
    MdArrowBack,
    MdArrowBackIos,
    MdArrowDownward,
    MdArrowForward,
    MdArrowUpward,
    MdBolt,
    MdCheck,
    MdChevronRight,
    MdClose,
    MdContentCopy,
    MdCrop169,
    MdCropDin,
    MdCropSquare,
    MdDescription,
    MdExpandLess,
    MdExpandMore,
    MdFormatListBulleted,
    MdHorizontalRule,
    MdInfoOutline,
    MdInsertDriveFile,
    MdLayersClear,
    MdLock,
    MdModeEditOutline,
    MdOfflineBolt,
    MdOndemandVideo,
    MdOpenInBrowser,
    MdOpenInNew,
    MdOutlineAdd,
    MdOutlineBurstMode,
    MdOutlineCloseFullscreen,
    MdOutlineCode,
    MdOutlineFileDownload,
    MdOutlineFileUpload,
    MdOutlineFilterNone,
    MdOutlineImage,
    MdOutlineRateReview,
    MdOutlineSelectAll,
    MdOutlineStorage,
    MdOutlineSubtitles,
    MdOutlineTableChart,
    MdOutlineTableRows,
    MdOutlineTitle,
    MdOutlineViewDay,
    MdOutlineWidthFull,
    MdPhotoFilter,
    MdRedo,
    MdRefresh,
    MdSmartButton,
    MdStarHalf,
    MdStayCurrentLandscape,
    MdStayCurrentPortrait,
    MdStoreMallDirectory,
    MdSubdirectoryArrowLeft,
    MdTextFields,
    MdUndo
};
const CustomIcons = {
    SwPencil: Pencil,
    SwGear: Gear,
    SwGoal: Goal,
    SwText: Text,
    SwGrid: Grid,
    SwMenu: Menu,
    SwPlus: Plus,
    SwPolaroid: Polaroid,
    SwPhoto: Photo
};
export const Icons = {
    ...Io5Icons,
    ...MdIcons,
    ...CustomIcons
};
const Base = tw.div`
${({ $flipHorizontal })=>$flipHorizontal ? `scale-x-[-1]` : ""}
  text-md
  ${({ $color })=>$color}
`;
const colors = {
    white: "text-white",
    whiteOpacity20: "text-white text-opacity-20",
    whiteOpacity80: "text-white text-opacity-80",
    whiteOpacity90: "text-white text-opacity-90",
    accentLight: "text-accent-light",
    accent: "text-accent-primary",
    accentDark: "text-accent-dark",
    alert: "text-alert-primary",
    dark: "text-[#13151A]"
};
const sizes = {
    xs: {
        fontSize: "0.75rem",
        lineHeight: "1rem"
    },
    sm: {
        fontSize: "0.875rem",
        lineHeight: "1.25rem"
    },
    base: {
        fontSize: "1rem",
        lineHeight: "1.5rem"
    },
    lg: {
        fontSize: "1.125rem",
        lineHeight: "1.75rem"
    },
    xl: {
        fontSize: "1.25rem" /* 20px */ ,
        lineHeight: "1.75rem" /* 28px */ 
    },
    ["2xl"]: {
        fontSize: "1.5rem" /* 24px */ ,
        lineHeight: "2rem" /* 32px */ 
    },
    ["3xl"]: {
        fontSize: "1.875rem" /* 30px */ ,
        lineHeight: "2.25remm" /* 36px */ 
    }
};
const Icon = ({ name, color = "accentLight", size = "base", flipHorizontal = false })=>{
    const Icon = Icons[name];
    if (!Icon) return null;
    const textColor = colors[color];
    const fontSize = sizes[size]?.fontSize;
    const lineHeight = sizes[size]?.lineHeight;
    return /*#__PURE__*/ _jsx(Base, {
        "aria-label": name,
        $color: textColor,
        $flipHorizontal: flipHorizontal,
        children: /*#__PURE__*/ _jsx(Icon, {
            style: {
                fontSize,
                lineHeight
            }
        })
    });
};
export default Icon;
